"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionShape = exports.formShape = exports.fieldShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldShape = _propTypes.default.shape({
  name: _propTypes.default.string,
  value: _propTypes.default.any,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func
});

exports.fieldShape = fieldShape;

var formShape = _propTypes.default.shape({
  touched: _propTypes.default.object,
  errors: _propTypes.default.object,
  setFieldTouched: _propTypes.default.func
});

exports.formShape = formShape;

var optionShape = _propTypes.default.shape({
  label: _propTypes.default.node.isRequired,
  value: _propTypes.default.any.isRequired
});

exports.optionShape = optionShape;